// extracted by mini-css-extract-plugin
export default {"container":"video_container__+D-Sy","wrapper":"video_wrapper__P9Bs1","title":"video_title__QqctC"};